module.exports = __webpack_public_path__ + "static/media/4.a5ce56f0.jpg";